<template>
  <div class="pc_only">
    <h2 class="kojin-title" style="background-color:orange"><slot>タイトル</slot></h2>
  </div>
  
  <span class="sp_only">
      <span class="sp-title" style="color:#FFF;background: #FF8400;" v-on:click="home()">
        ← <slot>タイトル</slot>
<!--        
        <input type="text" class="form-control" v-if="GlobalData.user_name" v-bind:value="GlobalData.user_name" readonly="readonly">
          <input type="text" class="form-control" v-else-if="GlobalData.$profile" value="未登録" readonly="readonly">
          <input type="text" class="form-control" v-else value="----------------------------------------------------------------------------------" readonly="readonly">
-->
        </span>
  </span>
  
  <div id="manual_area" >

  <span v-on:click="manual_open"><img class="m_icon" src="../../images/mark/manual.png"  />チェックインのマニュアル</span>
  <span class="pc_only"  v-on:click="qanda_open"><img class="m_icon" src="../../images/mark/QandA.png"  />システムQ&A</span>

  </div>
    
  <br clear="all">
  <div class="p-2" style="margin-top:0;background-color:white">
   
    <!-- パンくずリスト -->
    <nav class="pc_only" style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" v-on:click="home" style="cursor:pointer">Home</li>
        <li class="breadcrumb-item active" aria-current="page"><slot>タイトル</slot></li>
      </ol>
    </nav>

    <!-- カメラ表示部分 -->
     <!-- PCのカメラ(フロントにカメラがある場合)は、映像を左右反転させる
    <qrcode-stream @detect="onDetect"></qrcode-stream>-->
    <div v-if="isMobile" id="qr-code-full-region"></div>
    <div v-else id="qr-code-full-region" style="transform: scaleX(-1);"></div>
    </div>
      <!--メッセージを表示するモーダルウィンドウ-->
      <component v-bind:is="contentMessage"
                v-bind:message_text="message"
                v-bind:message_cat="message_cat"
                v-bind:message_flag="message_flag"
                @close_message="Close_message"
                @ok_message="OK_message"/>


      
</template>

<script setup>
/* eslint-disable */ 
import { useRouter,useRoute } from 'vue-router'
import { onMounted, ref, onBeforeUnmount } from 'vue';
import { Html5Qrcode } from "html5-qrcode";

import { QrcodeStream } from 'vue-qrcode-reader'
/* メッセージを表示するモーダルウィンドウ */
import MessageModal from '../common/MessageModal.vue'  

let message = ref("")//表示するメッセージ
let message_cat = ref(0)// メッセージのカテゴリ（0：OKのみ、1：OK or キャンセルの選択式）
let message_method = ref("")// こちら（親コンポーネント）に帰った時、どの処理（関数）を行うのか（message_catが1の時のみ）
let message_flag = ref(false)//表示・非表示フラグ

/* 表示する子コンポーネント関係の情報 */
const contentMessage = ref('')// 表示する子コンポーネントの情報（メッセージ表示エリア）
contentMessage.value = null // 表示する子コンポーネント

// スマホかどうかの判定
const isMobile = ref(/Android|iPhone|iPad/i.test(navigator.userAgent))

//const fileInput = ref(null);
const router = useRouter()
const route = useRoute()
const prop = defineProps(['param'])
const cityname = route.params.shakyo
const facility = route.params.shisetsu

const emit = defineEmits(['call'])
emit('call', { cmd:'page_scroll'})

// キャンセル対象の体験プログラムID
//let cancel_taiken_id = 0;
let qrcode  // null入れたらnew(インスタンスの生成時)の場所で型エラーが出たので初期値は無し nullを入れるとVariant型になるみたい

onMounted (() => {
  let constraints = {}
  Html5Qrcode.getCameras().then(devices => {
    /**
     * devices would be an array of objects of type:
     * { id: "id", label: "label" }
     */
    if (devices && devices.length) {
      let cameraId = devices[0].id; //デバイスのカメラIDを取得
      //alert(cameraId)

      constraints.fps = 10   // フレームレートの設定
      if (isMobile.value) {
        // ▼ スマホ：背面カメラを要求
        constraints.qrbox = { width: 250, height: 250 }   // QRコードのフレームの解像度の設定
        constraints.videoConstraints = { facingMode: "environment" }   // exact を付けないのがポイント
      } else {
        // ▼ PC：getCameras() で取得した cameraId を使用（フロント側）
        constraints.qrbox = { width: 250, height: 250 }   // QRコードのフレームの解像度の設定
        constraints.videoConstraints = { deviceId: { exact: cameraId } }   // facingMode を使わない
      }

      qrcode = new Html5Qrcode("qr-code-full-region");
      qrcode.start(
        isMobile.value ? { facingMode: "environment" } : cameraId, 
        constraints,
//        cameraId, 
//        {
//          fps: 10,
//          qrbox: { width: 250, height: 250 },  // カメラ上に表示される枠
//          videoConstraints: {
//            facingMode: { exact: "environment" },
//          },
//        },
        (decodedText, decodedResult) => {
          
          // コードから取得したURLをスラッシュ区切りで配列に変換
          // 0：https:
          // 1：（空）
          // 2：ドメイン部分
          // 3：社協区分（kawagoe、tsurugashima等）
          // 4：画面区分（Taiken）
          // 5：コマンド部分（checktaiken or checkjizen or checkjigo以外の時はエラー）
          // 6：プログラムID
          // 7：体験ユーザーID
          
        qrcode.stop().then((ignore) => {
            // QR Code scanning is stopped.
          }).catch((err) => {
            // Stop failed, handle it.
            console.log('stopCameras error:', err);
          });
          let checkin_url = decodedText.split("/")
          if(checkin_url[5] == "checktaiken" && checkin_url.length == 8){
            // チェックインに使う二次元コード以外を読み取っている場合
            emit('call', { cmd:"loading_start" })
            emit('call', { cmd:checkin_url[5], t_id:checkin_url[6], tu_id:checkin_url[7] })
          }else{
            message.value = "チェックイン用ではない二次元コードを読み取っています。";
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "qr_error";
            contentMessage.value = MessageModal 
          }
          // do something when code is read
        },
        (errorMessage) => {
          // parse error, ignore it.
        })
      .catch((err) => {
        // Start failed, handle it.
        console.log('startCameras error:', err);
      });
    }
  }).catch(err => {
    alert("エラー：カメラを取得できませんでした。")
    // handle err
    console.log('getCameras error:', err);
  });
})
//------------------- 体験プログラム一覧表示へ
const home = () => {
/*  画面が遷移される(unmountとかが発行される遷移)とカメラは切れますが、画面のcontentの入れ替えでは、カメラは切れません。
  if(qrcode != null){
    qrcode.stop()
    qrcode = null
  }
  emit('call', { cmd:'init'})
*/
  router.push("/"+cityname+"/"+facility+"/Shisetsu").then(() => {
      router.go(0)   // ← ページ全体を再ロード（フルリロード）
  })
}



// メッセージを表示するウィンドウでOKを押された時
let OK_message = function(){ 
    Close_message();//メッセージを表示するウィンドウを閉じる
    if(message_method.value == "qr_error"){
        // 同一URLの場合は直接親を呼ぶ
        emit('call', { cmd:'Readcode'})
    }
}

// メッセージを表示するウィンドウを閉じる
let Close_message = function(){
    message_flag.value = false;
    contentMessage.value = null
}

let manual_open = function(){
    let url = "https://zest-newsprint-e3e.notion.site/167c0be34f8f807aa5e5cc3e2512c4f5"
    window.open(url,"_blank")
}

// Q&Aを開く
const qanda_open = () =>{

  let url = "https://zest-newsprint-e3e.notion.site/Q-A-175c0be34f8f801998fac72f169fb66b"
  window.open(url,"_blank")
} 

async function stopCamera() {
  try {
    if (qrcode && qrcode.isScanning) {
      await qrcode.stop();   // カメラ停止
    }
  } catch (e) {
    console.log("カメラのストップでエラー："+e)
  }
  try {
    if (qrcode) {
      await qrcode.clear();  // DOM後始末
    }
  } catch (e) {
    console.log("カメラのクリアでエラー："+e)
  }
}

onBeforeUnmount(() => {
  // onBeforeUnmount は async にできないので fire-and-forget
  stopCamera();
});

</script>
<style scoped>
.taiken_table{
  cursor:pointer;
}
.taiken_table:hover{
  
  background-color:royalblue;
}

#qr-code-full-region__dashboard{
  display: none;
}

@media screen and (min-width: 961px) {

/* PC版 */

  .floating_over,.sp_button_area{
      display: none
  }
}
@media screen and (max-width: 960px) {

  /* スマホ版 */

  .floating_over{
      display: flex
  }
  .sp_button_area{
    display:block;
  }

}
</style>
